enum InspectionStates {
  Passed = 'Passed',
  Failed = 'Failed',
}

export default InspectionStates
